// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.export-btn-enhanced {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: 2px solid rgba(40, 167, 69, 0.2);
  color: white !important;
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);
  cursor: pointer;
  position: relative;
}
[data-coreui-theme=dark] .export-btn-enhanced {
  background: linear-gradient(135deg, #198754 0%, #20c997 100%);
  border-color: rgba(32, 201, 151, 0.3);
  box-shadow: 0 4px 15px rgba(32, 201, 151, 0.3);
}
.export-btn-enhanced::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
  z-index: 1;
}
.export-btn-enhanced:hover {
  background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(32, 201, 151, 0.35);
  color: white !important;
  text-decoration: none;
}
.export-btn-enhanced:hover::before {
  left: 100%;
}
.export-btn-enhanced:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(32, 201, 151, 0.2);
}
.export-btn-enhanced:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(32, 201, 151, 0.3);
}
.export-btn-enhanced:disabled {
  background: #6c757d !important;
  border-color: #6c757d;
  color: #fff !important;
  cursor: not-allowed;
  transform: none;
}
.export-btn-enhanced:disabled:hover {
  background: #6c757d !important;
  transform: none;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.15);
}
.export-btn-enhanced .export-icon {
  transition: transform 0.3s ease;
  font-size: 1.1em;
  position: relative;
  z-index: 2;
}
.export-btn-enhanced:hover .export-icon {
  transform: scale(1.1);
}
.export-btn-enhanced .export-text {
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 2;
}

.export-modal-enhanced .modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.98);
  overflow: hidden;
  position: relative;
}
[data-coreui-theme=dark] .export-modal-enhanced .modal-content {
  background: rgba(33, 37, 41, 0.98);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
}
.export-modal-enhanced .modal-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #28a745, #20c997, #17a2b8, #28a745);
  background-size: 200% 100%;
  animation: gradientFlow 3s ease-in-out infinite;
  z-index: 1;
}
.export-modal-enhanced .export-modal-header {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border-radius: 20px 20px 0 0;
  padding: 1.5rem 2rem;
  border: none;
  position: relative;
  overflow: hidden;
}
.export-modal-enhanced .export-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 50%, rgba(255, 255, 255, 0.1) 100%);
  animation: shimmer 3s infinite;
}
.export-modal-enhanced .export-modal-header .export-modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 3;
  margin: 0;
  font-size: 1.25rem;
  color: white;
}
.export-modal-enhanced .export-modal-header .export-modal-title::before {
  content: "📊";
  margin-right: 12px;
  font-size: 1.2em;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  animation: iconPulse 2s ease-in-out infinite;
}
.export-modal-enhanced .export-modal-header .btn-close {
  filter: brightness(0) invert(1) !important;
  opacity: 0.8 !important;
  transition: all 0.3s ease !important;
  position: relative !important;
  z-index: 4 !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.1) !important;
  width: 32px !important;
  height: 32px !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.export-modal-enhanced .export-modal-header .btn-close::before {
  content: "✕" !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 1 !important;
  position: relative !important;
  z-index: 1 !important;
}
.export-modal-enhanced .export-modal-header .btn-close:hover {
  opacity: 1 !important;
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.1);
}
.export-modal-enhanced .export-modal-header .btn-close:focus {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3) !important;
  outline: none !important;
}
.export-modal-enhanced .export-modal-header .btn-close:active {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: scale(0.95);
}
.export-modal-enhanced .export-modal-body {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  position: relative;
  /* Export Scope Styles */
  /* Format Section Styles */
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body {
  background: rgba(255, 255, 255, 0.05);
}
.export-modal-enhanced .export-modal-body .export-description {
  font-size: 1rem;
  color: var(--table-text-color);
  margin-bottom: 1.5rem;
  font-weight: 500;
  position: relative;
  z-index: 1;
  text-align: center;
}
.export-modal-enhanced .export-modal-body .export-section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #28a745;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgba(40, 167, 69, 0.1);
  position: relative;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .export-section-title {
  color: #20c997;
  border-bottom-color: rgba(32, 201, 151, 0.2);
}
.export-modal-enhanced .export-modal-body .export-section-title::before {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 50px;
  height: 2px;
  background: linear-gradient(90deg, #28a745, #20c997);
  border-radius: 1px;
}
.export-modal-enhanced .export-modal-body .export-scope-section {
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
}
.export-modal-enhanced .export-modal-body .export-scope-toggle {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.export-modal-enhanced .export-modal-body .scope-option-wrapper {
  position: relative;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option {
  position: relative;
  margin: 0;
  padding: 1.25rem 1.5rem;
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid rgba(40, 167, 69, 0.15);
  border-radius: 15px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  overflow: hidden;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .scope-toggle-option {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(32, 201, 151, 0.2);
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:hover {
  border-color: rgba(40, 167, 69, 0.4);
  background: rgba(40, 167, 69, 0.08);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:hover .scope-content {
  transform: translateX(3px);
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) {
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.1);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.15);
  transform: translateY(-1px);
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) .scope-radio-custom {
  background: #28a745;
  border-color: #28a745;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) .scope-radio-custom::after {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) .scope-content .scope-title {
  color: #28a745;
  font-weight: 700;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) .scope-content .scope-title {
  color: #20c997;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) .scope-content .scope-description {
  color: #17a2b8;
  font-weight: 600;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .scope-toggle-option:has(.scope-radio-input:checked) .scope-content .scope-description {
  color: #20c997;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-radio-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 0;
  height: 0;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-radio-custom {
  width: 24px;
  height: 24px;
  border: 3px solid #dee2e6;
  border-radius: 50%;
  background: transparent;
  margin-right: 1rem;
  position: relative;
  flex-shrink: 0;
  transition: all 0.3s ease;
  z-index: 1;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-radio-custom::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
  transition: opacity 0.2s ease, transform 0.2s ease;
  opacity: 0;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content {
  flex: 1 1;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 1;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--table-text-color);
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-title::before {
  content: "📄";
  font-size: 1.1em;
}
.export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-description {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-description {
  color: #adb5bd;
}
.export-modal-enhanced .export-modal-body .export-format-section {
  margin-bottom: 1.5rem;
  position: relative;
  z-index: 1;
}
.export-modal-enhanced .export-modal-body .export-format-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.export-modal-enhanced .export-modal-body .export-format-option {
  position: relative;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check {
  position: relative;
  margin: 0;
  padding: 1.25rem 1.5rem;
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid rgba(40, 167, 69, 0.15);
  border-radius: 12px;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .enhanced-radio-check {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(32, 201, 151, 0.2);
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check:hover {
  border-color: rgba(40, 167, 69, 0.4);
  background: rgba(40, 167, 69, 0.08);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check:has(.form-check-input:checked) {
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.1);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.15);
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check:has(.form-check-input:checked) .form-check-label {
  font-weight: 600;
  color: #28a745;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .enhanced-radio-check:has(.form-check-input:checked) .form-check-label {
  color: #20c997;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-input {
  width: 22px;
  height: 22px;
  margin-top: 0;
  margin-right: 1rem;
  border: 2px solid #28a745;
  background: transparent;
  position: relative;
  flex-shrink: 0;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-input:checked {
  background: #28a745;
  border-color: #28a745;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-input:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-input:focus {
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25);
  border-color: #28a745;
  outline: none;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-label {
  font-size: 1rem;
  font-weight: 500;
  color: var(--table-text-color);
  cursor: pointer;
  transition: none;
  position: relative;
  z-index: 1;
  margin: 0;
  display: flex;
  align-items: center;
  line-height: 1.4;
  flex: 1 1;
}
.export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-label::before {
  content: "📄";
  margin-right: 0.75rem;
  font-size: 1.2em;
}
.export-modal-enhanced .export-modal-body .export-info-section {
  background: rgba(23, 162, 184, 0.1);
  padding: 1.25rem;
  border-radius: 12px;
  border-left: 4px solid #17a2b8;
  margin-top: 1.5rem;
  position: relative;
  z-index: 1;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .export-info-section {
  background: rgba(23, 162, 184, 0.15);
}
.export-modal-enhanced .export-modal-body .export-info-section .export-info-content small {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #17a2b8;
  font-weight: 500;
  display: block;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .export-info-section .export-info-content small {
  color: #20c997;
}
.export-modal-enhanced .export-modal-body .export-info-section .export-info-content small strong {
  color: #28a745;
  font-weight: 700;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .export-info-section .export-info-content small strong {
  color: #20c997;
}
.export-modal-enhanced .export-modal-footer {
  padding: 1.5rem 2rem 2rem;
  border: none;
  background: rgba(248, 249, 250, 0.8);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-footer {
  background: rgba(33, 37, 41, 0.8);
}
.export-modal-enhanced .export-modal-footer .export-cancel-btn {
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  position: relative;
  overflow: hidden;
  background: rgba(108, 117, 125, 0.1) !important;
  border: 2px solid rgba(108, 117, 125, 0.3) !important;
  color: #6c757d !important;
  backdrop-filter: blur(10px);
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-footer .export-cancel-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: #e9ecef !important;
}
.export-modal-enhanced .export-modal-footer .export-cancel-btn:hover {
  background: #6c757d !important;
  border-color: #6c757d !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);
}
.export-modal-enhanced .export-modal-footer .export-cancel-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.25);
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn {
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.2s ease;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  border: none !important;
  color: white !important;
  display: flex;
  align-items: center;
  gap: 8px;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:hover {
  background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(32, 201, 151, 0.4);
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:hover .export-confirm-icon {
  animation: gentleBounce 0.6s ease;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:hover .download-icon {
  animation: downloadPulse 0.8s ease;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:hover .download-icon::before {
  animation: downloadBox 0.8s ease;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:hover .download-icon::after {
  animation: downloadArrow 0.8s ease;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(32, 201, 151, 0.2);
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:disabled {
  background: #6c757d !important;
  transform: none;
  box-shadow: none;
  cursor: not-allowed;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:disabled:hover {
  background: #6c757d !important;
  transform: none;
  box-shadow: none;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(32, 201, 151, 0.3);
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .export-confirm-icon {
  transition: transform 0.3s ease;
  font-size: 1.1em;
  position: relative;
  z-index: 1;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .download-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: relative;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .download-icon::before {
  content: "";
  position: absolute;
  top: 3px;
  left: 50%;
  transform: translateX(-50%);
  width: 14px;
  height: 10px;
  border: 2px solid currentColor;
  border-bottom: none;
  border-radius: 3px 3px 0 0;
  background: currentColor;
  opacity: 0.1;
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .download-icon::after {
  content: "";
  position: absolute;
  top: 9px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid currentColor;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .download-icon:hover::before {
  opacity: 0.2;
  transform: translateX(-50%) scale(1.05);
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .download-icon:hover::after {
  transform: translateX(-50%) translateY(1px);
}
.export-modal-enhanced .export-modal-footer .export-confirm-btn .export-confirm-text {
  position: relative;
  z-index: 1;
}

@media (max-width: 768px) {
  .export-btn-enhanced {
    padding: 8px 16px;
    font-size: 0.8rem;
  }
  .export-btn-enhanced .export-text {
    font-size: 0.8rem;
  }
  .export-modal-enhanced .modal-content {
    margin: 1rem;
    border-radius: 16px;
  }
  .export-modal-enhanced .modal-content::before {
    height: 3px;
  }
  .export-modal-enhanced .export-modal-header {
    padding: 1rem 1.5rem;
    border-radius: 16px 16px 0 0;
  }
  .export-modal-enhanced .export-modal-header .export-modal-title {
    font-size: 1.1rem;
  }
  .export-modal-enhanced .export-modal-header .export-modal-title::before {
    margin-right: 8px;
    font-size: 1.1em;
  }
  .export-modal-enhanced .export-modal-body {
    padding: 1.5rem;
  }
  .export-modal-enhanced .export-modal-body .export-scope-toggle {
    gap: 0.75rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option {
    padding: 1rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option .scope-radio-custom {
    width: 20px;
    height: 20px;
    margin-right: 0.75rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-title {
    font-size: 1rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-description {
    font-size: 0.85rem;
  }
  .export-modal-enhanced .export-modal-body .enhanced-radio-check {
    padding: 1rem;
    margin-bottom: 0.75rem;
  }
  .export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-input {
    width: 20px;
    height: 20px;
    margin-right: 0.75rem;
  }
  .export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-label {
    font-size: 0.9rem;
  }
  .export-modal-enhanced .export-modal-body .export-info-section {
    padding: 1rem;
    margin-top: 1rem;
  }
  .export-modal-enhanced .export-modal-body .export-info-section .export-info-content small {
    font-size: 0.8rem;
  }
  .export-modal-enhanced .export-modal-footer {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  .export-modal-enhanced .export-modal-footer .export-cancel-btn, .export-modal-enhanced .export-modal-footer .export-confirm-btn {
    padding: 10px 20px;
    font-size: 0.9rem;
    width: 100%;
  }
}
/* Güzel Animasyonlar - Performanslı */
@keyframes gradientFlow {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes gentleBounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}
@keyframes downloadPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  25% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  75% {
    transform: scale(1.08);
    opacity: 0.85;
  }
}
@keyframes downloadBox {
  0%, 100% {
    transform: translateX(-50%) scale(1);
    opacity: 0.1;
  }
  50% {
    transform: translateX(-50%) scale(1.1);
    opacity: 0.3;
  }
}
@keyframes downloadArrow {
  0%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(2px);
  }
}
@media (max-width: 576px) {
  .export-modal-enhanced .modal-content {
    margin: 0.5rem;
  }
  .export-modal-enhanced .export-modal-body {
    padding: 1rem;
  }
  .export-modal-enhanced .export-modal-body .export-description {
    font-size: 0.9rem;
    margin-bottom: 1rem;
  }
  .export-modal-enhanced .export-modal-body .export-section-title {
    font-size: 0.9rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option {
    padding: 0.75rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-title {
    font-size: 0.9rem;
  }
  .export-modal-enhanced .export-modal-body .scope-toggle-option .scope-content .scope-description {
    font-size: 0.8rem;
  }
  .export-modal-enhanced .export-modal-body .enhanced-radio-check {
    padding: 0.75rem;
  }
  .export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-label {
    font-size: 0.85rem;
  }
  .export-modal-enhanced .export-modal-body .enhanced-radio-check .form-check-label::before {
    font-size: 1em;
    margin-right: 0.5rem;
  }
}
[data-coreui-theme=dark] .export-modal-enhanced .modal-content {
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.6);
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .scope-toggle-option:hover {
  box-shadow: 0 10px 25px rgba(32, 201, 151, 0.2);
}
[data-coreui-theme=dark] .export-modal-enhanced .export-modal-body .enhanced-radio-check:hover {
  box-shadow: 0 8px 20px rgba(32, 201, 151, 0.2);
}

/* Mevcut tüm stillerin yanına bu kısımları ekleyin */
/* Export Actions Section */
.export-actions-section {
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
}

.export-action-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.export-action-btn {
  border-radius: 12px;
  padding: 1rem 1.5rem;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.2s ease;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 140px;
  justify-content: center;
  backdrop-filter: blur(10px);
}
.export-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.export-action-btn:hover .action-icon {
  animation: gentleBounce 0.6s ease;
}
.export-action-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}
.export-action-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}
.export-action-btn .action-icon {
  font-size: 1.2em;
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}
.export-action-btn .action-text {
  position: relative;
  z-index: 1;
  font-size: 0.95rem;
}

.preview-btn {
  border: 2px solid rgba(13, 110, 253, 0.3) !important;
  background: rgba(13, 110, 253, 0.1) !important;
  color: #0d6efd !important;
}
[data-coreui-theme=dark] .preview-btn {
  border-color: rgba(13, 110, 253, 0.4) !important;
  background: rgba(13, 110, 253, 0.15) !important;
  color: #6ea8fe !important;
}
.preview-btn:hover {
  background: #0d6efd !important;
  border-color: #0d6efd !important;
  color: white !important;
}

.print-btn {
  border: 2px solid rgba(13, 202, 240, 0.3) !important;
  background: rgba(13, 202, 240, 0.1) !important;
  color: #0dcaf0 !important;
}
[data-coreui-theme=dark] .print-btn {
  border-color: rgba(13, 202, 240, 0.4) !important;
  background: rgba(13, 202, 240, 0.15) !important;
  color: #6edff6 !important;
}
.print-btn:hover {
  background: #0dcaf0 !important;
  border-color: #0dcaf0 !important;
  color: white !important;
}

/* Preview Modal Styles */
.export-preview-modal .modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.98);
  overflow: hidden;
  position: relative;
}
[data-coreui-theme=dark] .export-preview-modal .modal-content {
  background: rgba(33, 37, 41, 0.98);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
}
.export-preview-modal .modal-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #0d6efd, #0dcaf0);
  z-index: 1;
}
.export-preview-modal .preview-modal-header {
  background: linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%);
  color: white;
  border-radius: 20px 20px 0 0;
  padding: 1.5rem 2rem;
  border: none;
  position: relative;
  overflow: hidden;
}
.export-preview-modal .preview-modal-header .preview-modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
  margin: 0;
  font-size: 1.25rem;
  color: white;
}
.export-preview-modal .preview-modal-header .preview-modal-title::before {
  content: "👁️";
  margin-right: 12px;
  font-size: 1.2em;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}
.export-preview-modal .preview-modal-header .btn-close {
  filter: brightness(0) invert(1) !important;
  opacity: 0.8 !important;
  transition: opacity 0.2s ease !important;
  position: relative !important;
  z-index: 3 !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.1) !important;
  width: 32px !important;
  height: 32px !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.export-preview-modal .preview-modal-header .btn-close::before {
  content: "✕" !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: bold !important;
  line-height: 1 !important;
  position: relative !important;
  z-index: 1 !important;
}
.export-preview-modal .preview-modal-header .btn-close:hover {
  opacity: 1 !important;
  background: rgba(255, 255, 255, 0.2) !important;
}
.export-preview-modal .preview-modal-body {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  max-height: 70vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body {
  background: rgba(255, 255, 255, 0.05);
}
.export-preview-modal .preview-modal-body .preview-info {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: rgba(13, 110, 253, 0.1);
  border-radius: 12px;
  border-left: 4px solid #0d6efd;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-info {
  background: rgba(13, 110, 253, 0.15);
}
.export-preview-modal .preview-modal-body .preview-info .preview-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  font-size: 0.9rem;
  color: #0d6efd;
  font-weight: 500;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-info .preview-meta {
  color: #6ea8fe;
}
.export-preview-modal .preview-modal-body .preview-info .preview-meta span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.export-preview-modal .preview-modal-body .preview-info .preview-meta span::before {
  content: "•";
  color: #0dcaf0;
  font-weight: bold;
}
.export-preview-modal .preview-modal-body .preview-info .preview-meta span:first-child::before {
  content: "📊";
}
.export-preview-modal .preview-modal-body .preview-info .preview-meta span:nth-child(2)::before {
  content: "📋";
}
.export-preview-modal .preview-modal-body .preview-info .preview-meta span:last-child::before {
  content: "👀";
}
.export-preview-modal .preview-modal-body .preview-table-container {
  flex: 1 1;
  overflow: auto;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-table-container {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
}
.export-preview-modal .preview-modal-body .preview-table-container .preview-table {
  margin: 0;
}
.export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #495057;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 1rem 0.75rem;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  z-index: 10;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-header {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  color: #e9ecef;
  border-bottom-color: rgba(255, 255, 255, 0.1);
}
.export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-cell {
  padding: 0.75rem;
  font-size: 0.875rem;
  vertical-align: middle;
  border-color: rgba(0, 0, 0, 0.05);
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-cell {
  border-color: rgba(255, 255, 255, 0.05);
}
.export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-cell:hover {
  background-color: rgba(13, 110, 253, 0.05);
  white-space: normal;
  word-wrap: break-word;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-cell:hover {
  background-color: rgba(13, 110, 253, 0.1);
}
.export-preview-modal .preview-modal-body .preview-table-container .preview-table tbody tr {
  transition: all 0.2s ease;
}
.export-preview-modal .preview-modal-body .preview-table-container .preview-table tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.05);
  transform: translateX(2px);
  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.1);
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-table-container .preview-table tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.1);
}
.export-preview-modal .preview-modal-body .preview-note {
  margin-top: 1rem;
  text-align: center;
  padding: 0.75rem;
  background: rgba(255, 193, 7, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(255, 193, 7, 0.3);
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-note {
  background: rgba(255, 193, 7, 0.15);
}
.export-preview-modal .preview-modal-body .preview-note small {
  color: #856404;
  font-style: italic;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-body .preview-note small {
  color: #ffeaa7;
}
.export-preview-modal .preview-modal-footer {
  padding: 1.5rem 2rem 2rem;
  border: none;
  background: rgba(248, 249, 250, 0.8);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-footer {
  background: rgba(33, 37, 41, 0.8);
}
.export-preview-modal .preview-modal-footer .preview-print-btn {
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background: rgba(13, 202, 240, 0.1) !important;
  border: 2px solid rgba(13, 202, 240, 0.3) !important;
  color: #0dcaf0 !important;
  display: flex;
  align-items: center;
  gap: 8px;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-footer .preview-print-btn {
  background: rgba(13, 202, 240, 0.15) !important;
  border-color: rgba(13, 202, 240, 0.4) !important;
  color: #6edff6 !important;
}
.export-preview-modal .preview-modal-footer .preview-print-btn:hover {
  background: #0dcaf0 !important;
  border-color: #0dcaf0 !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(13, 202, 240, 0.3);
}
.export-preview-modal .preview-modal-footer .preview-print-btn:disabled {
  background: #6c757d !important;
  border-color: #6c757d !important;
  color: white !important;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.export-preview-modal .preview-modal-footer .preview-print-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}
.export-preview-modal .preview-modal-footer .preview-print-btn .action-icon,
.export-preview-modal .preview-modal-footer .preview-print-btn .action-text {
  position: relative;
  z-index: 1;
}
.export-preview-modal .preview-modal-footer .preview-close-btn {
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background: rgba(108, 117, 125, 0.1) !important;
  border: 2px solid rgba(108, 117, 125, 0.3) !important;
  color: #6c757d !important;
}
[data-coreui-theme=dark] .export-preview-modal .preview-modal-footer .preview-close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: #e9ecef !important;
}
.export-preview-modal .preview-modal-footer .preview-close-btn:hover {
  background: #6c757d !important;
  border-color: #6c757d !important;
  color: white !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .export-action-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }
  .export-action-btn {
    width: 100%;
    padding: 0.875rem 1.25rem;
    min-width: auto;
  }
  .export-action-btn .action-text {
    font-size: 0.9rem;
  }
  .export-preview-modal .modal-content {
    margin: 1rem;
    border-radius: 16px;
  }
  .export-preview-modal .modal-content::before {
    height: 3px;
  }
  .export-preview-modal .preview-modal-header {
    padding: 1rem 1.5rem;
    border-radius: 16px 16px 0 0;
  }
  .export-preview-modal .preview-modal-header .preview-modal-title {
    font-size: 1.1rem;
  }
  .export-preview-modal .preview-modal-header .preview-modal-title::before {
    margin-right: 8px;
    font-size: 1.1em;
  }
  .export-preview-modal .preview-modal-body {
    padding: 1.5rem;
  }
  .export-preview-modal .preview-modal-body .preview-info {
    padding: 0.75rem;
  }
  .export-preview-modal .preview-modal-body .preview-info .preview-meta {
    flex-direction: column;
    gap: 0.75rem;
    font-size: 0.85rem;
  }
  .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-header {
    font-size: 0.8rem;
    padding: 0.75rem 0.5rem;
  }
  .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-cell {
    padding: 0.5rem;
    font-size: 0.8rem;
    max-width: 150px;
  }
  .export-preview-modal .preview-modal-footer {
    padding: 1rem 1.5rem 1.5rem;
    flex-direction: column;
    gap: 0.75rem;
  }
  .export-preview-modal .preview-modal-footer .preview-print-btn,
  .export-preview-modal .preview-modal-footer .preview-close-btn {
    width: 100%;
    padding: 10px 20px;
    font-size: 0.9rem;
  }
}
@media (max-width: 576px) {
  .export-preview-modal .modal-content {
    margin: 0.5rem;
  }
  .export-preview-modal .preview-modal-body {
    padding: 1rem;
  }
  .export-preview-modal .preview-modal-body .preview-info {
    margin-bottom: 1rem;
  }
  .export-preview-modal .preview-modal-body .preview-info .preview-meta {
    font-size: 0.8rem;
  }
  .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-header {
    font-size: 0.75rem;
    padding: 0.5rem 0.4rem;
  }
  .export-preview-modal .preview-modal-body .preview-table-container .preview-table .preview-cell {
    padding: 0.4rem;
    font-size: 0.75rem;
    max-width: 120px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ExportData/ExportData.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,wCAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yDAAA;EACA,gBAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;AAEF;AAAE;EACE,6DAAA;EACA,qCAAA;EACA,8CAAA;AAEJ;AACE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;EACA,UAAA;AACJ;AAEE;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;EACA,uBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAIE;EACE,wBAAA;EACA,6CAAA;AAFJ;AAKE;EACE,aAAA;EACA,6CAAA;AAHJ;AAME;EACE,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;AAMI;EACE,8BAAA;EACA,eAAA;EACA,+CAAA;AAJN;AAQE;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AANJ;AASE;EACE,qBAAA;AAPJ;AAUE;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AARJ;;AAaE;EACE,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,2BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AAYI;EACE,kCAAA;EACA,0CAAA;AAVN;AAaI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sEAAA;EACA,0BAAA;EACA,+CAAA;EACA,UAAA;AAXN;AAeE;EACE,6DAAA;EACA,YAAA;EACA,4BAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;AAeI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6HAAA;EACA,8BAAA;AAbN;AAgBI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AAdN;AAgBM;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,4CAAA;AAdR;AAkBI;EACE,0CAAA;EACA,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,qBAAA;EACA,6BAAA;EACA,+CAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AAhBN;AAkBM;EACE,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;AAhBR;AAmBM;EACE,qBAAA;EACA,+CAAA;EACA,qBAAA;AAjBR;AAoBM;EACE,yDAAA;EACA,wBAAA;AAlBR;AAqBM;EACE,+CAAA;EACA,sBAAA;AAnBR;AAwBE;EACE,aAAA;EACA,oCAAA;EACA,2BAAA;EACA,kBAAA;EA2CA,wBAAA;EAyJA,0BAAA;AAxNJ;AAsBI;EACE,qCAAA;AApBN;AAwBI;EACE,eAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AAtBN;AAyBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,+CAAA;EACA,kBAAA;AAvBN;AAyBM;EACE,cAAA;EACA,4CAAA;AAvBR;AA0BM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oDAAA;EACA,kBAAA;AAxBR;AA6BI;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;AA3BN;AA8BI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5BN;AA+BI;EACE,kBAAA;AA7BN;AAgCI;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;EACA,yCAAA;EACA,mBAAA;EACA,8DAAA;EACA,eAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA9BN;AAgCM;EACE,qCAAA;EACA,qCAAA;AA9BR;AAiCM;EACE,oCAAA;EACA,mCAAA;EACA,2BAAA;EACA,8CAAA;AA/BR;AAiCQ;EACE,0BAAA;AA/BV;AAmCM;EACE,qBAAA;EACA,kCAAA;EACA,8CAAA;EACA,2BAAA;AAjCR;AAmCQ;EACE,mBAAA;EACA,qBAAA;EACA,4CAAA;AAjCV;AAmCU;EACE,UAAA;EACA,yCAAA;AAjCZ;AAsCU;EACE,cAAA;EACA,gBAAA;AApCZ;AAsCY;EACE,cAAA;AApCd;AAwCU;EACE,cAAA;EACA,gBAAA;AAtCZ;AAwCY;EACE,cAAA;AAtCd;AA4CM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AA1CR;AA6CM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;AA3CR;AA6CQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kDAAA;EACA,UAAA;AA3CV;AA+CM;EACE,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;AA7CR;AA+CQ;EACE,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA7CV;AA+CU;EACE,aAAA;EACA,gBAAA;AA7CZ;AAiDQ;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AA/CV;AAiDU;EACE,cAAA;AA/CZ;AAsDI;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;AApDN;AAuDI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArDN;AAwDI;EACE,kBAAA;AAtDN;AAyDI;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,oCAAA;EACA,yCAAA;EACA,mBAAA;EACA,8DAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;AAvDN;AAyDM;EACE,qCAAA;EACA,qCAAA;AAvDR;AA0DM;EACE,oCAAA;EACA,mCAAA;EACA,2BAAA;EACA,8CAAA;AAxDR;AA2DM;EACE,qBAAA;EACA,kCAAA;EACA,8CAAA;AAzDR;AA2DQ;EACE,gBAAA;EACA,cAAA;AAzDV;AA2DU;EACE,cAAA;AAzDZ;AA8DM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AA5DR;AA8DQ;EACE,mBAAA;EACA,qBAAA;AA5DV;AA8DU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AA5DZ;AAgEQ;EACE,6CAAA;EACA,qBAAA;EACA,aAAA;AA9DV;AAkEM;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAhER;AAkEQ;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAhEV;AAqEI;EACE,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAnEN;AAqEM;EACE,oCAAA;AAnER;AAuEQ;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AArEV;AAuEU;EACE,cAAA;AArEZ;AAwEU;EACE,cAAA;EACA,gBAAA;AAtEZ;AAuEY;EACE,cAAA;AArEd;AA6EE;EACE,yBAAA;EACA,YAAA;EACA,oCAAA;EACA,2BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AA3EJ;AA6EI;EACE,iCAAA;AA3EN;AA8EI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8DAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,qDAAA;EACA,yBAAA;EACA,2BAAA;AA5EN;AA8EM;EACE,+CAAA;EACA,iDAAA;EACA,yBAAA;AA5ER;AA+EM;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,2BAAA;EACA,8CAAA;AA7ER;AAgFM;EACE,aAAA;EACA,+CAAA;AA9ER;AAkFI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;EACA,gBAAA;EACA,wEAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhFN;AAkFM;EACE,wEAAA;EACA,2BAAA;EACA,8CAAA;AAhFR;AAkFQ;EACE,iCAAA;AAhFV;AAmFQ;EACE,kCAAA;AAjFV;AAmFU;EACE,gCAAA;AAjFZ;AAoFU;EACE,kCAAA;AAlFZ;AAuFM;EACE,wBAAA;EACA,6CAAA;AArFR;AAuFM;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AArFR;AAsFQ;EACE,8BAAA;EACA,eAAA;EACA,gBAAA;AApFV;AAuFM;EACE,aAAA;EACA,6CAAA;AArFR;AAuFM;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AArFR;AAwFM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAtFR;AAwFQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,YAAA;AAtFV;AAyFQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,iDAAA;AAvFV;AA2FU;EACE,YAAA;EACA,uCAAA;AAzFZ;AA4FU;EACE,2CAAA;AA1FZ;AA8FM;EACE,kBAAA;EACA,UAAA;AA5FR;;AAmGA;EACE;IACE,iBAAA;IACA,iBAAA;EAhGF;EAiGE;IACE,iBAAA;EA/FJ;EAoGE;IACE,YAAA;IACA,mBAAA;EAlGJ;EAmGI;IACE,WAAA;EAjGN;EAqGE;IACE,oBAAA;IACA,4BAAA;EAnGJ;EAoGI;IACE,iBAAA;EAlGN;EAmGM;IACE,iBAAA;IACA,gBAAA;EAjGR;EAsGE;IACE,eAAA;EApGJ;EAsGI;IACE,YAAA;EApGN;EAuGI;IACE,aAAA;EArGN;EAuGM;IACE,WAAA;IACA,YAAA;IACA,qBAAA;EArGR;EAyGQ;IACE,eAAA;EAvGV;EA0GQ;IACE,kBAAA;EAxGV;EA6GI;IACE,aAAA;IACA,sBAAA;EA3GN;EA4GM;IACE,WAAA;IACA,YAAA;IACA,qBAAA;EA1GR;EA4GM;IACE,iBAAA;EA1GR;EA8GI;IACE,aAAA;IACA,gBAAA;EA5GN;EA6GM;IACE,iBAAA;EA3GR;EAgHE;IACE,2BAAA;IACA,sBAAA;IACA,YAAA;EA9GJ;EA+GI;IACE,kBAAA;IACA,iBAAA;IACA,WAAA;EA7GN;AACF;AAkHA,sCAAA;AACA;EACE;IAAK,2BAAA;EA/GL;EAgHA;IAAM,6BAAA;EA7GN;EA8GA;IAAO,2BAAA;EA3GP;AACF;AA6GA;EACE;IAAW,mBAAA;EA1GX;EA2GA;IAAM,sBAAA;EAxGN;AACF;AA0GA;EACE;IAAK,4BAAA;EAvGL;EAwGA;IAAO,2BAAA;EArGP;AACF;AAuGA;EACE;IAAW,wBAAA;EApGX;EAqGA;IAAM,2BAAA;EAlGN;AACF;AAoGA;EACE;IACE,mBAAA;IACA,UAAA;EAlGF;EAoGA;IACE,qBAAA;IACA,YAAA;EAlGF;EAoGA;IACE,sBAAA;IACA,YAAA;EAlGF;EAoGA;IACE,sBAAA;IACA,aAAA;EAlGF;AACF;AAqGA;EACE;IACE,oCAAA;IACA,YAAA;EAnGF;EAqGA;IACE,sCAAA;IACA,YAAA;EAnGF;AACF;AAsGA;EACE;IACE,yCAAA;EApGF;EAsGA;IACE,2CAAA;EApGF;AACF;AAuGA;EAEI;IACE,cAAA;EAtGJ;EAyGE;IACE,aAAA;EAvGJ;EAyGI;IACE,iBAAA;IACA,mBAAA;EAvGN;EA0GI;IACE,iBAAA;EAxGN;EA2GI;IACE,gBAAA;EAzGN;EA4GQ;IACE,iBAAA;EA1GV;EA6GQ;IACE,iBAAA;EA3GV;EAgHI;IACE,gBAAA;EA9GN;EA+GM;IACE,kBAAA;EA7GR;EA8GQ;IACE,cAAA;IACA,oBAAA;EA5GV;AACF;AAqHI;EACE,0CAAA;AAnHN;AAwHQ;EACE,+CAAA;AAtHV;AA2HQ;EACE,8CAAA;AAzHV;;AA+HA,qDAAA;AAEA,2BAAA;AACA;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;AA7HF;;AAgIA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA7HF;;AAgIA;EACE,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,2DAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;AA7HF;AA+HE;EACE,2BAAA;EACA,0CAAA;AA7HJ;AA+HI;EACE,iCAAA;AA7HN;AAiIE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AA/HJ;AAiII;EACE,eAAA;EACA,gBAAA;AA/HN;AAmIE;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,+BAAA;AAjIJ;AAoIE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AAlIJ;;AAsIA;EACE,oDAAA;EACA,8CAAA;EACA,yBAAA;AAnIF;AAqIE;EACE,gDAAA;EACA,+CAAA;EACA,yBAAA;AAnIJ;AAsIE;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;AApIJ;;AAwIA;EACE,oDAAA;EACA,8CAAA;EACA,yBAAA;AArIF;AAuIE;EACE,gDAAA;EACA,+CAAA;EACA,yBAAA;AArIJ;AAwIE;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;AAtIJ;;AA0IA,yBAAA;AAEE;EACE,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,2BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;AAxIJ;AA0II;EACE,kCAAA;EACA,0CAAA;AAxIN;AA2II;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;EACA,UAAA;AAzIN;AA6IE;EACE,6DAAA;EACA,YAAA;EACA,4BAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AA3IJ;AA6II;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AA3IN;AA6IM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AA3IR;AA+II;EACE,0CAAA;EACA,uBAAA;EACA,wCAAA;EACA,6BAAA;EACA,qBAAA;EACA,6BAAA;EACA,+CAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AA7IN;AA+IM;EACE,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;AA7IR;AAgJM;EACE,qBAAA;EACA,+CAAA;AA9IR;AAmJE;EACE,aAAA;EACA,oCAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAjJJ;AAmJI;EACE,qCAAA;AAjJN;AAoJI;EACE,qBAAA;EACA,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,8BAAA;AAlJN;AAoJM;EACE,oCAAA;AAlJR;AAqJM;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAnJR;AAqJQ;EACE,cAAA;AAnJV;AAsJQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AApJV;AAsJU;EACE,YAAA;EACA,cAAA;EACA,iBAAA;AApJZ;AAuJU;EACE,aAAA;AArJZ;AAwJU;EACE,aAAA;AAtJZ;AAyJU;EACE,aAAA;AAvJZ;AA6JI;EACE,SAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,iBAAA;EACA,yCAAA;AA3JN;AA6JM;EACE,qCAAA;EACA,sCAAA;AA3JR;AA8JM;EACE,SAAA;AA5JR;AA8JQ;EACE,6DAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gCAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AA5JV;AA8JU;EACE,gGAAA;EACA,cAAA;EACA,6CAAA;AA5JZ;AAgKQ;EACE,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9JV;AAgKU;EACE,uCAAA;AA9JZ;AAiKU;EACE,0CAAA;EACA,mBAAA;EACA,qBAAA;AA/JZ;AAiKY;EACE,yCAAA;AA/Jd;AAoKQ;EACE,yBAAA;AAlKV;AAoKU;EACE,0CAAA;EACA,0BAAA;EACA,6CAAA;AAlKZ;AAoKY;EACE,yCAAA;AAlKd;AAyKI;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;AAvKN;AAyKM;EACE,mCAAA;AAvKR;AA0KM;EACE,cAAA;EACA,kBAAA;AAxKR;AA0KQ;EACE,cAAA;AAxKV;AA8KE;EACE,yBAAA;EACA,YAAA;EACA,oCAAA;EACA,2BAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AA5KJ;AA8KI;EACE,iCAAA;AA5KN;AA+KI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,oDAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA7KN;AA+KM;EACE,+CAAA;EACA,gDAAA;EACA,yBAAA;AA7KR;AAgLM;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,2BAAA;EACA,8CAAA;AA9KR;AAiLM;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/KR;AAiLQ;EACE,eAAA;EACA,gBAAA;AA/KV;AAmLM;;EAEE,kBAAA;EACA,UAAA;AAjLR;AAqLI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,qDAAA;EACA,yBAAA;AAnLN;AAqLM;EACE,+CAAA;EACA,iDAAA;EACA,yBAAA;AAnLR;AAsLM;EACE,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,2BAAA;EACA,8CAAA;AApLR;;AA2LA,sBAAA;AACA;EACE;IACE,sBAAA;IACA,YAAA;EAxLF;EA2LA;IACE,WAAA;IACA,yBAAA;IACA,eAAA;EAzLF;EA2LE;IACE,iBAAA;EAzLJ;EA8LE;IACE,YAAA;IACA,mBAAA;EA5LJ;EA8LI;IACE,WAAA;EA5LN;EAgME;IACE,oBAAA;IACA,4BAAA;EA9LJ;EAgMI;IACE,iBAAA;EA9LN;EAgMM;IACE,iBAAA;IACA,gBAAA;EA9LR;EAmME;IACE,eAAA;EAjMJ;EAmMI;IACE,gBAAA;EAjMN;EAmMM;IACE,sBAAA;IACA,YAAA;IACA,kBAAA;EAjMR;EAuMQ;IACE,iBAAA;IACA,uBAAA;EArMV;EAwMQ;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAtMV;EA4ME;IACE,2BAAA;IACA,sBAAA;IACA,YAAA;EA1MJ;EA4MI;;IAEE,WAAA;IACA,kBAAA;IACA,iBAAA;EA1MN;AACF;AA+MA;EAEI;IACE,cAAA;EA9MJ;EAiNE;IACE,aAAA;EA/MJ;EAiNI;IACE,mBAAA;EA/MN;EAiNM;IACE,iBAAA;EA/MR;EAqNQ;IACE,kBAAA;IACA,sBAAA;EAnNV;EAsNQ;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;EApNV;AACF","sourcesContent":[".export-btn-enhanced {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  border: 2px solid rgba(40, 167, 69, 0.2);\n  color: white !important;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-decoration: none;\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.2);\n  cursor: pointer;\n  position: relative;\n\n  [data-coreui-theme=\"dark\"] & {\n    background: linear-gradient(135deg, #198754 0%, #20c997 100%);\n    border-color: rgba(32, 201, 151, 0.3);\n    box-shadow: 0 4px 15px rgba(32, 201, 151, 0.3);\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n    transition: left 0.5s ease;\n    z-index: 1;\n  }\n\n  &:hover {\n    background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%);\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(32, 201, 151, 0.35);\n    color: white !important;\n    text-decoration: none;\n\n    &::before {\n      left: 100%;\n    }\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 6px rgba(32, 201, 151, 0.2);\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(32, 201, 151, 0.3);\n  }\n\n  &:disabled {\n    background: #6c757d !important;\n    border-color: #6c757d;\n    color: #fff !important;\n    cursor: not-allowed;\n    transform: none;\n\n    &:hover {\n      background: #6c757d !important;\n      transform: none;\n      box-shadow: 0 2px 8px rgba(108, 117, 125, 0.15);\n    }\n  }\n\n  .export-icon {\n    transition: transform 0.3s ease;\n    font-size: 1.1em;\n    position: relative;\n    z-index: 2;\n  }\n\n  &:hover .export-icon {\n    transform: scale(1.1);\n  }\n\n  .export-text {\n    font-size: 0.9rem;\n    letter-spacing: 0.5px;\n    position: relative;\n    z-index: 2;\n  }\n}\n\n.export-modal-enhanced {\n  .modal-content {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n    backdrop-filter: blur(20px);\n    background: rgba(255, 255, 255, 0.98);\n    overflow: hidden;\n    position: relative;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.98);\n      box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 4px;\n      background: linear-gradient(90deg, #28a745, #20c997, #17a2b8, #28a745);\n      background-size: 200% 100%;\n      animation: gradientFlow 3s ease-in-out infinite;\n      z-index: 1;\n    }\n  }\n\n  .export-modal-header {\n    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n    color: white;\n    border-radius: 20px 20px 0 0;\n    padding: 1.5rem 2rem;\n    border: none;\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 50%, rgba(255, 255, 255, 0.1) 100%);\n      animation: shimmer 3s infinite;\n    }\n\n    .export-modal-title {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      position: relative;\n      z-index: 3;\n      margin: 0;\n      font-size: 1.25rem;\n      color: white;\n\n      &::before {\n        content: '📊';\n        margin-right: 12px;\n        font-size: 1.2em;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n        animation: iconPulse 2s ease-in-out infinite;\n      }\n    }\n\n    .btn-close {\n      filter: brightness(0) invert(1) !important;\n      opacity: 0.8 !important;\n      transition: all 0.3s ease !important;\n      position: relative !important;\n      z-index: 4 !important;\n      border-radius: 50% !important;\n      background: rgba(255, 255, 255, 0.1) !important;\n      width: 32px !important;\n      height: 32px !important;\n      border: none !important;\n      padding: 0 !important;\n      margin: 0 !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n\n      &::before {\n        content: '✕' !important;\n        color: white !important;\n        font-size: 14px !important;\n        font-weight: bold !important;\n        line-height: 1 !important;\n        position: relative !important;\n        z-index: 1 !important;\n      }\n\n      &:hover {\n        opacity: 1 !important;\n        background: rgba(255, 255, 255, 0.2) !important;\n        transform: scale(1.1);\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3) !important;\n        outline: none !important;\n      }\n\n      &:active {\n        background: rgba(255, 255, 255, 0.3) !important;\n        transform: scale(0.95);\n      }\n    }\n  }\n\n  .export-modal-body {\n    padding: 2rem;\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(10px);\n    position: relative;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(255, 255, 255, 0.05);\n    }\n\n\n    .export-description {\n      font-size: 1rem;\n      color: var(--table-text-color);\n      margin-bottom: 1.5rem;\n      font-weight: 500;\n      position: relative;\n      z-index: 1;\n      text-align: center;\n    }\n\n    .export-section-title {\n      font-size: 1rem;\n      font-weight: 600;\n      color: #28a745;\n      margin-bottom: 1rem;\n      padding-bottom: 0.5rem;\n      border-bottom: 2px solid rgba(40, 167, 69, 0.1);\n      position: relative;\n\n      [data-coreui-theme=\"dark\"] & {\n        color: #20c997;\n        border-bottom-color: rgba(32, 201, 151, 0.2);\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        left: 0;\n        width: 50px;\n        height: 2px;\n        background: linear-gradient(90deg, #28a745, #20c997);\n        border-radius: 1px;\n      }\n    }\n\n    /* Export Scope Styles */\n    .export-scope-section {\n      margin-bottom: 2rem;\n      position: relative;\n      z-index: 1;\n    }\n\n    .export-scope-toggle {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n\n    .scope-option-wrapper {\n      position: relative;\n    }\n\n    .scope-toggle-option {\n      position: relative;\n      margin: 0;\n      padding: 1.25rem 1.5rem;\n      background: rgba(255, 255, 255, 0.9);\n      border: 2px solid rgba(40, 167, 69, 0.15);\n      border-radius: 15px;\n      transition: border-color 0.2s ease, background-color 0.2s ease;\n      cursor: pointer;\n      backdrop-filter: blur(10px);\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.08);\n        border-color: rgba(32, 201, 151, 0.2);\n      }\n\n      &:hover {\n        border-color: rgba(40, 167, 69, 0.4);\n        background: rgba(40, 167, 69, 0.08);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);\n        \n        .scope-content {\n          transform: translateX(3px);\n        }\n      }\n\n      &:has(.scope-radio-input:checked) {\n        border-color: #28a745;\n        background: rgba(40, 167, 69, 0.1);\n        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.15);\n        transform: translateY(-1px);\n\n        .scope-radio-custom {\n          background: #28a745;\n          border-color: #28a745;\n          box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.2);\n\n          &::after {\n            opacity: 1;\n            transform: translate(-50%, -50%) scale(1);\n          }\n        }\n\n        .scope-content {\n          .scope-title {\n            color: #28a745;\n            font-weight: 700;\n\n            [data-coreui-theme=\"dark\"] & {\n              color: #20c997;\n            }\n          }\n\n          .scope-description {\n            color: #17a2b8;\n            font-weight: 600;\n\n            [data-coreui-theme=\"dark\"] & {\n              color: #20c997;\n            }\n          }\n        }\n      }\n\n      .scope-radio-input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        width: 0;\n        height: 0;\n      }\n\n      .scope-radio-custom {\n        width: 24px;\n        height: 24px;\n        border: 3px solid #dee2e6;\n        border-radius: 50%;\n        background: transparent;\n        margin-right: 1rem;\n        position: relative;\n        flex-shrink: 0;\n        transition: all 0.3s ease;\n        z-index: 1;\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%) scale(0);\n          width: 10px;\n          height: 10px;\n          background: white;\n          border-radius: 50%;\n          transition: opacity 0.2s ease, transform 0.2s ease;\n          opacity: 0;\n        }\n      }\n\n      .scope-content {\n        flex: 1;\n        transition: transform 0.3s ease;\n        position: relative;\n        z-index: 1;\n\n        .scope-title {\n          font-size: 1.1rem;\n          font-weight: 600;\n          color: var(--table-text-color);\n          margin-bottom: 0.3rem;\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n\n          &::before {\n            content: '📄';\n            font-size: 1.1em;\n          }\n        }\n\n        .scope-description {\n          font-size: 0.9rem;\n          color: #6c757d;\n          font-weight: 500;\n\n          [data-coreui-theme=\"dark\"] & {\n            color: #adb5bd;\n          }\n        }\n      }\n    }\n\n    /* Format Section Styles */\n    .export-format-section {\n      margin-bottom: 1.5rem;\n      position: relative;\n      z-index: 1;\n    }\n\n    .export-format-options {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n\n    .export-format-option { \n      position: relative; \n    }\n\n    .enhanced-radio-check {\n      position: relative;\n      margin: 0;\n      padding: 1.25rem 1.5rem;\n      background: rgba(255, 255, 255, 0.8);\n      border: 2px solid rgba(40, 167, 69, 0.15);\n      border-radius: 12px;\n      transition: border-color 0.2s ease, background-color 0.2s ease;\n      cursor: pointer;\n      backdrop-filter: blur(5px);\n      display: flex;\n      align-items: center;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.05);\n        border-color: rgba(32, 201, 151, 0.2);\n      }\n\n      &:hover {\n        border-color: rgba(40, 167, 69, 0.4);\n        background: rgba(40, 167, 69, 0.08);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 20px rgba(40, 167, 69, 0.15);\n      }\n\n      &:has(.form-check-input:checked) {\n        border-color: #28a745;\n        background: rgba(40, 167, 69, 0.1);\n        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.15);\n\n        .form-check-label {\n          font-weight: 600;\n          color: #28a745;\n\n          [data-coreui-theme=\"dark\"] & { \n            color: #20c997; \n          }\n        }\n      }\n\n      .form-check-input {\n        width: 22px;\n        height: 22px;\n        margin-top: 0;\n        margin-right: 1rem;\n        border: 2px solid #28a745;\n        background: transparent;\n        position: relative;\n        flex-shrink: 0;\n\n        &:checked {\n          background: #28a745;\n          border-color: #28a745;\n\n          &::after {\n            content: '';\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            width: 8px;\n            height: 8px;\n            background: white;\n            border-radius: 50%;\n          }\n        }\n\n        &:focus { \n          box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25); \n          border-color: #28a745; \n          outline: none; \n        }\n      }\n\n      .form-check-label {\n        font-size: 1rem;\n        font-weight: 500;\n        color: var(--table-text-color);\n        cursor: pointer;\n        transition: none;\n        position: relative;\n        z-index: 1;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        line-height: 1.4;\n        flex: 1;\n\n        &::before { \n          content: '📄'; \n          margin-right: 0.75rem; \n          font-size: 1.2em; \n        }\n      }\n    }\n\n    .export-info-section {\n      background: rgba(23, 162, 184, 0.1);\n      padding: 1.25rem;\n      border-radius: 12px;\n      border-left: 4px solid #17a2b8;\n      margin-top: 1.5rem;\n      position: relative;\n      z-index: 1;\n\n      [data-coreui-theme=\"dark\"] & { \n        background: rgba(23, 162, 184, 0.15); \n      }\n\n      .export-info-content {\n        small {\n          font-size: 0.875rem;\n          line-height: 1.6;\n          color: #17a2b8;\n          font-weight: 500;\n          display: block;\n\n          [data-coreui-theme=\"dark\"] & { \n            color: #20c997; \n          }\n\n          strong {\n            color: #28a745;\n            font-weight: 700;\n            [data-coreui-theme=\"dark\"] & { \n              color: #20c997; \n            }\n          }\n        }\n      }\n    }\n  }\n\n  .export-modal-footer {\n    padding: 1.5rem 2rem 2rem;\n    border: none;\n    background: rgba(248, 249, 250, 0.8);\n    backdrop-filter: blur(10px);\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n\n    [data-coreui-theme=\"dark\"] & { \n      background: rgba(33, 37, 41, 0.8); \n    }\n\n    .export-cancel-btn {\n      border-radius: 12px;\n      padding: 12px 24px;\n      font-weight: 600;\n      transition: background-color 0.2s ease, border-color 0.2s ease;\n      position: relative;\n      overflow: hidden;\n      background: rgba(108, 117, 125, 0.1) !important;\n      border: 2px solid rgba(108, 117, 125, 0.3) !important;\n      color: #6c757d !important;\n      backdrop-filter: blur(10px);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.1) !important;\n        border-color: rgba(255, 255, 255, 0.2) !important;\n        color: #e9ecef !important;\n      }\n\n      &:hover {\n        background: #6c757d !important;\n        border-color: #6c757d !important;\n        color: white !important;\n        transform: translateY(-1px);\n        box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);\n      }\n\n      &:focus { \n        outline: none; \n        box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.25); \n      }\n    }\n\n    .export-confirm-btn {\n      border-radius: 12px;\n      padding: 12px 24px;\n      font-weight: 600;\n      transition: background-color 0.2s ease, transform 0.2s ease;\n      position: relative;\n      overflow: hidden;\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;\n      border: none !important;\n      color: white !important;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      &:hover {\n        background: linear-gradient(135deg, #20c997 0%, #17a2b8 100%) !important;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(32, 201, 151, 0.4);\n        \n        .export-confirm-icon {\n          animation: gentleBounce 0.6s ease;\n        }\n        \n        .download-icon {\n          animation: downloadPulse 0.8s ease;\n          \n          &::before {\n            animation: downloadBox 0.8s ease;\n          }\n          \n          &::after {\n            animation: downloadArrow 0.8s ease;\n          }\n        }\n      }\n\n      &:active { \n        transform: translateY(0); \n        box-shadow: 0 2px 8px rgba(32, 201, 151, 0.2); \n      }\n      &:disabled {\n        background: #6c757d !important;\n        transform: none;\n        box-shadow: none;\n        cursor: not-allowed;\n        &:hover { \n          background: #6c757d !important; \n          transform: none; \n          box-shadow: none; \n        }\n      }\n      &:focus { \n        outline: none; \n        box-shadow: 0 0 0 2px rgba(32, 201, 151, 0.3); \n      }\n      .export-confirm-icon { \n        transition: transform 0.3s ease; \n        font-size: 1.1em; \n        position: relative; \n        z-index: 1; \n      }\n\n      .download-icon {\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        position: relative;\n        \n        &::before {\n          content: '';\n          position: absolute;\n          top: 3px;\n          left: 50%;\n          transform: translateX(-50%);\n          width: 14px;\n          height: 10px;\n          border: 2px solid currentColor;\n          border-bottom: none;\n          border-radius: 3px 3px 0 0;\n          background: currentColor;\n          opacity: 0.1;\n        }\n        \n        &::after {\n          content: '';\n          position: absolute;\n          top: 9px;\n          left: 50%;\n          transform: translateX(-50%);\n          width: 0;\n          height: 0;\n          border-left: 5px solid transparent;\n          border-right: 5px solid transparent;\n          border-top: 7px solid currentColor;\n          filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));\n        }\n        \n        &:hover {\n          &::before {\n            opacity: 0.2;\n            transform: translateX(-50%) scale(1.05);\n          }\n          \n          &::after {\n            transform: translateX(-50%) translateY(1px);\n          }\n        }\n      }\n      .export-confirm-text { \n        position: relative; \n        z-index: 1; \n      }\n    }\n  }\n}\n\n\n@media (max-width: 768px) {\n  .export-btn-enhanced { \n    padding: 8px 16px; \n    font-size: 0.8rem; \n    .export-text { \n      font-size: 0.8rem; \n    } \n  }\n  \n  .export-modal-enhanced {\n    .modal-content { \n      margin: 1rem; \n      border-radius: 16px; \n      &::before { \n        height: 3px; \n      } \n    }\n    \n    .export-modal-header { \n      padding: 1rem 1.5rem; \n      border-radius: 16px 16px 0 0; \n      .export-modal-title { \n        font-size: 1.1rem; \n        &::before { \n          margin-right: 8px; \n          font-size: 1.1em; \n        } \n      } \n    }\n    \n    .export-modal-body {\n      padding: 1.5rem;\n      \n      .export-scope-toggle {\n        gap: 0.75rem;\n      }\n      \n      .scope-toggle-option { \n        padding: 1rem; \n        \n        .scope-radio-custom {\n          width: 20px;\n          height: 20px;\n          margin-right: 0.75rem;\n        }\n        \n        .scope-content {\n          .scope-title {\n            font-size: 1rem;\n          }\n          \n          .scope-description {\n            font-size: 0.85rem;\n          }\n        }\n      }\n      \n      .enhanced-radio-check { \n        padding: 1rem; \n        margin-bottom: 0.75rem; \n        .form-check-input { \n          width: 20px; \n          height: 20px; \n          margin-right: 0.75rem; \n        } \n        .form-check-label { \n          font-size: 0.9rem; \n        } \n      }\n      \n      .export-info-section { \n        padding: 1rem; \n        margin-top: 1rem; \n        .export-info-content small { \n          font-size: 0.8rem; \n        } \n      }\n    }\n    \n    .export-modal-footer { \n      padding: 1rem 1.5rem 1.5rem; \n      flex-direction: column; \n      gap: 0.75rem; \n      .export-cancel-btn, .export-confirm-btn { \n        padding: 10px 20px; \n        font-size: 0.9rem; \n        width: 100%; \n      } \n    }\n  }\n}\n\n/* Güzel Animasyonlar - Performanslı */\n@keyframes gradientFlow {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n@keyframes iconPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n@keyframes gentleBounce {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-2px); }\n}\n\n@keyframes downloadPulse {\n  0%, 100% { \n    transform: scale(1);\n    opacity: 1;\n  }\n  25% { \n    transform: scale(1.1);\n    opacity: 0.8;\n  }\n  50% { \n    transform: scale(1.05);\n    opacity: 0.9;\n  }\n  75% { \n    transform: scale(1.08);\n    opacity: 0.85;\n  }\n}\n\n@keyframes downloadBox {\n  0%, 100% { \n    transform: translateX(-50%) scale(1);\n    opacity: 0.1;\n  }\n  50% { \n    transform: translateX(-50%) scale(1.1);\n    opacity: 0.3;\n  }\n}\n\n@keyframes downloadArrow {\n  0%, 100% { \n    transform: translateX(-50%) translateY(0);\n  }\n  50% { \n    transform: translateX(-50%) translateY(2px);\n  }\n}\n\n@media (max-width: 576px) {\n  .export-modal-enhanced { \n    .modal-content { \n      margin: 0.5rem; \n    } \n    \n    .export-modal-body { \n      padding: 1rem; \n      \n      .export-description { \n        font-size: 0.9rem; \n        margin-bottom: 1rem; \n      } \n      \n      .export-section-title {\n        font-size: 0.9rem;\n      }\n      \n      .scope-toggle-option {\n        padding: 0.75rem;\n        \n        .scope-content {\n          .scope-title {\n            font-size: 0.9rem;\n          }\n          \n          .scope-description {\n            font-size: 0.8rem;\n          }\n        }\n      }\n      \n      .enhanced-radio-check { \n        padding: 0.75rem; \n        .form-check-label { \n          font-size: 0.85rem; \n          &::before { \n            font-size: 1em; \n            margin-right: 0.5rem; \n          } \n        } \n      } \n    } \n  }\n}\n\n[data-coreui-theme=\"dark\"] { \n  .export-modal-enhanced { \n    .modal-content { \n      box-shadow: 0 25px 50px rgba(0, 0, 0, 0.6); \n    } \n    \n    .export-modal-body { \n      .scope-toggle-option {\n        &:hover { \n          box-shadow: 0 10px 25px rgba(32, 201, 151, 0.2); \n        } \n      }\n      \n      .enhanced-radio-check { \n        &:hover { \n          box-shadow: 0 8px 20px rgba(32, 201, 151, 0.2); \n        } \n      } \n    } \n  } \n}\n/* Mevcut tüm stillerin yanına bu kısımları ekleyin */\n\n/* Export Actions Section */\n.export-actions-section {\n  margin-bottom: 2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.export-action-buttons {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.export-action-btn {\n  border-radius: 12px;\n  padding: 1rem 1.5rem;\n  font-weight: 600;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 140px;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n    \n    .action-icon {\n      animation: gentleBounce 0.6s ease;\n    }\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n    transform: none;\n    box-shadow: none;\n\n    &:hover {\n      transform: none;\n      box-shadow: none;\n    }\n  }\n\n  .action-icon {\n    font-size: 1.2em;\n    position: relative;\n    z-index: 1;\n    transition: transform 0.3s ease;\n  }\n\n  .action-text {\n    position: relative;\n    z-index: 1;\n    font-size: 0.95rem;\n  }\n}\n\n.preview-btn {\n  border: 2px solid rgba(13, 110, 253, 0.3) !important;\n  background: rgba(13, 110, 253, 0.1) !important;\n  color: #0d6efd !important;\n\n  [data-coreui-theme=\"dark\"] & {\n    border-color: rgba(13, 110, 253, 0.4) !important;\n    background: rgba(13, 110, 253, 0.15) !important;\n    color: #6ea8fe !important;\n  }\n\n  &:hover {\n    background: #0d6efd !important;\n    border-color: #0d6efd !important;\n    color: white !important;\n  }\n}\n\n.print-btn {\n  border: 2px solid rgba(13, 202, 240, 0.3) !important;\n  background: rgba(13, 202, 240, 0.1) !important;\n  color: #0dcaf0 !important;\n\n  [data-coreui-theme=\"dark\"] & {\n    border-color: rgba(13, 202, 240, 0.4) !important;\n    background: rgba(13, 202, 240, 0.15) !important;\n    color: #6edff6 !important;\n  }\n\n  &:hover {\n    background: #0dcaf0 !important;\n    border-color: #0dcaf0 !important;\n    color: white !important;\n  }\n}\n\n/* Preview Modal Styles */\n.export-preview-modal {\n  .modal-content {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n    backdrop-filter: blur(20px);\n    background: rgba(255, 255, 255, 0.98);\n    overflow: hidden;\n    position: relative;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.98);\n      box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 3px;\n      background: linear-gradient(90deg, #0d6efd, #0dcaf0);\n      z-index: 1;\n    }\n  }\n\n  .preview-modal-header {\n    background: linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%);\n    color: white;\n    border-radius: 20px 20px 0 0;\n    padding: 1.5rem 2rem;\n    border: none;\n    position: relative;\n    overflow: hidden;\n\n    .preview-modal-title {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      position: relative;\n      z-index: 2;\n      margin: 0;\n      font-size: 1.25rem;\n      color: white;\n\n      &::before {\n        content: '👁️';\n        margin-right: 12px;\n        font-size: 1.2em;\n        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));\n      }\n    }\n\n    .btn-close {\n      filter: brightness(0) invert(1) !important;\n      opacity: 0.8 !important;\n      transition: opacity 0.2s ease !important;\n      position: relative !important;\n      z-index: 3 !important;\n      border-radius: 50% !important;\n      background: rgba(255, 255, 255, 0.1) !important;\n      width: 32px !important;\n      height: 32px !important;\n      border: none !important;\n      padding: 0 !important;\n      margin: 0 !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n\n      &::before {\n        content: '✕' !important;\n        color: white !important;\n        font-size: 14px !important;\n        font-weight: bold !important;\n        line-height: 1 !important;\n        position: relative !important;\n        z-index: 1 !important;\n      }\n\n      &:hover {\n        opacity: 1 !important;\n        background: rgba(255, 255, 255, 0.2) !important;\n      }\n    }\n  }\n\n  .preview-modal-body {\n    padding: 2rem;\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(10px);\n    max-height: 70vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(255, 255, 255, 0.05);\n    }\n\n    .preview-info {\n      margin-bottom: 1.5rem;\n      padding: 1rem;\n      background: rgba(13, 110, 253, 0.1);\n      border-radius: 12px;\n      border-left: 4px solid #0d6efd;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(13, 110, 253, 0.15);\n      }\n\n      .preview-meta {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1.5rem;\n        font-size: 0.9rem;\n        color: #0d6efd;\n        font-weight: 500;\n\n        [data-coreui-theme=\"dark\"] & {\n          color: #6ea8fe;\n        }\n\n        span {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n\n          &::before {\n            content: '•';\n            color: #0dcaf0;\n            font-weight: bold;\n          }\n\n          &:first-child::before {\n            content: '📊';\n          }\n\n          &:nth-child(2)::before {\n            content: '📋';\n          }\n\n          &:last-child::before {\n            content: '👀';\n          }\n        }\n      }\n    }\n\n    .preview-table-container {\n      flex: 1;\n      overflow: auto;\n      border-radius: 12px;\n      border: 1px solid rgba(0, 0, 0, 0.1);\n      background: white;\n      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.05);\n        border-color: rgba(255, 255, 255, 0.1);\n      }\n\n      .preview-table {\n        margin: 0;\n\n        .preview-header {\n          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n          color: #495057;\n          font-weight: 600;\n          font-size: 0.875rem;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n          padding: 1rem 0.75rem;\n          border-bottom: 2px solid #dee2e6;\n          position: sticky;\n          top: 0;\n          z-index: 10;\n\n          [data-coreui-theme=\"dark\"] & {\n            background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n            color: #e9ecef;\n            border-bottom-color: rgba(255, 255, 255, 0.1);\n          }\n        }\n\n        .preview-cell {\n          padding: 0.75rem;\n          font-size: 0.875rem;\n          vertical-align: middle;\n          border-color: rgba(0, 0, 0, 0.05);\n          max-width: 200px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n\n          [data-coreui-theme=\"dark\"] & {\n            border-color: rgba(255, 255, 255, 0.05);\n          }\n\n          &:hover {\n            background-color: rgba(13, 110, 253, 0.05);\n            white-space: normal;\n            word-wrap: break-word;\n\n            [data-coreui-theme=\"dark\"] & {\n              background-color: rgba(13, 110, 253, 0.1);\n            }\n          }\n        }\n\n        tbody tr {\n          transition: all 0.2s ease;\n\n          &:hover {\n            background-color: rgba(13, 110, 253, 0.05);\n            transform: translateX(2px);\n            box-shadow: 0 2px 8px rgba(13, 110, 253, 0.1);\n\n            [data-coreui-theme=\"dark\"] & {\n              background-color: rgba(13, 110, 253, 0.1);\n            }\n          }\n        }\n      }\n    }\n\n    .preview-note {\n      margin-top: 1rem;\n      text-align: center;\n      padding: 0.75rem;\n      background: rgba(255, 193, 7, 0.1);\n      border-radius: 8px;\n      border: 1px solid rgba(255, 193, 7, 0.3);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 193, 7, 0.15);\n      }\n\n      small {\n        color: #856404;\n        font-style: italic;\n\n        [data-coreui-theme=\"dark\"] & {\n          color: #ffeaa7;\n        }\n      }\n    }\n  }\n\n  .preview-modal-footer {\n    padding: 1.5rem 2rem 2rem;\n    border: none;\n    background: rgba(248, 249, 250, 0.8);\n    backdrop-filter: blur(10px);\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.8);\n    }\n\n    .preview-print-btn {\n      border-radius: 12px;\n      padding: 12px 24px;\n      font-weight: 600;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow: hidden;\n      background: rgba(13, 202, 240, 0.1) !important;\n      border: 2px solid rgba(13, 202, 240, 0.3) !important;\n      color: #0dcaf0 !important;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(13, 202, 240, 0.15) !important;\n        border-color: rgba(13, 202, 240, 0.4) !important;\n        color: #6edff6 !important;\n      }\n\n      &:hover {\n        background: #0dcaf0 !important;\n        border-color: #0dcaf0 !important;\n        color: white !important;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 15px rgba(13, 202, 240, 0.3);\n      }\n\n      &:disabled {\n        background: #6c757d !important;\n        border-color: #6c757d !important;\n        color: white !important;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n\n        &:hover {\n          transform: none;\n          box-shadow: none;\n        }\n      }\n\n      .action-icon,\n      .action-text {\n        position: relative;\n        z-index: 1;\n      }\n    }\n\n    .preview-close-btn {\n      border-radius: 12px;\n      padding: 12px 24px;\n      font-weight: 600;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow: hidden;\n      background: rgba(108, 117, 125, 0.1) !important;\n      border: 2px solid rgba(108, 117, 125, 0.3) !important;\n      color: #6c757d !important;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.1) !important;\n        border-color: rgba(255, 255, 255, 0.2) !important;\n        color: #e9ecef !important;\n      }\n\n      &:hover {\n        background: #6c757d !important;\n        border-color: #6c757d !important;\n        color: white !important;\n        transform: translateY(-1px);\n        box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);\n      }\n    }\n  }\n}\n\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .export-action-buttons {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .export-action-btn {\n    width: 100%;\n    padding: 0.875rem 1.25rem;\n    min-width: auto;\n\n    .action-text {\n      font-size: 0.9rem;\n    }\n  }\n\n  .export-preview-modal {\n    .modal-content {\n      margin: 1rem;\n      border-radius: 16px;\n\n      &::before {\n        height: 3px;\n      }\n    }\n\n    .preview-modal-header {\n      padding: 1rem 1.5rem;\n      border-radius: 16px 16px 0 0;\n\n      .preview-modal-title {\n        font-size: 1.1rem;\n\n        &::before {\n          margin-right: 8px;\n          font-size: 1.1em;\n        }\n      }\n    }\n\n    .preview-modal-body {\n      padding: 1.5rem;\n\n      .preview-info {\n        padding: 0.75rem;\n\n        .preview-meta {\n          flex-direction: column;\n          gap: 0.75rem;\n          font-size: 0.85rem;\n        }\n      }\n\n      .preview-table-container {\n        .preview-table {\n          .preview-header {\n            font-size: 0.8rem;\n            padding: 0.75rem 0.5rem;\n          }\n\n          .preview-cell {\n            padding: 0.5rem;\n            font-size: 0.8rem;\n            max-width: 150px;\n          }\n        }\n      }\n    }\n\n    .preview-modal-footer {\n      padding: 1rem 1.5rem 1.5rem;\n      flex-direction: column;\n      gap: 0.75rem;\n\n      .preview-print-btn,\n      .preview-close-btn {\n        width: 100%;\n        padding: 10px 20px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .export-preview-modal {\n    .modal-content {\n      margin: 0.5rem;\n    }\n\n    .preview-modal-body {\n      padding: 1rem;\n\n      .preview-info {\n        margin-bottom: 1rem;\n\n        .preview-meta {\n          font-size: 0.8rem;\n        }\n      }\n\n      .preview-table-container {\n        .preview-table {\n          .preview-header {\n            font-size: 0.75rem;\n            padding: 0.5rem 0.4rem;\n          }\n\n          .preview-cell {\n            padding: 0.4rem;\n            font-size: 0.75rem;\n            max-width: 120px;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
